module.exports = __webpack_public_path__ + "static/media/game(23).3b900922.PNG";